<div class="ag-cell-content" [title]="value"> {{ value }} </div>